/** Service create/update field help copy (info tooltips). */
export const SERVICE_FIELD_HELP = {
  active: "Uncheck to disable this service so it is no longer offered.",
  type: "High-level service type classification.",
  category: "Main grouping (e.g., Consultation, Lab, Radiology).",
  subCategory: "Specific service type within the selected category.",
  modality: "Imaging modality (e.g., X-Ray, Ultrasound, CT).",
  serviceName: "Display name of the procedure or service.",
  hsnSacCode: "Tax/SAC classification code for services.",
  skuId: "Unique code to identify this service.",
  taxApplicability: "Whether GST/tax applies to this service.",
  tax: "Tax percentage applied when tax is applicable.",
  sampleType: "Type of sample required for lab tests.",
  diagnosticTemplate: "Template used for diagnostic reporting.",
  nextDue: "Suggested interval until the next due service.",
  nextDueType: "Unit for next due (e.g., days, weeks, months).",
  description: "Brief service details or notes.",
  linkedSubcategories:
    "Stock subcategories whose items become searchable for every variant of this service.",

  variants:
    "Define alternate configurations of this service (pricing, duration, etc.).",
  variantId: "Unique identifier for this variant.",
  variantName: "Name that distinguishes this service variant.",
  bomCharge:
    "Auto-calculated cost from consumables and administered items linked to the variant.",
  estimatedDuration: "Estimated time to complete the service, in minutes.",
  serviceCharge: "Professional or service fee charged for this variant.",
  bundledSellingPrice:
    "Total selling price for the service (including the BOM costs)",
  region: "Body region for radiology procedures.",
  device: "Equipment or device used for this procedure.",
  doneAt: "Where the procedure is performed (e.g., in-clinic, external).",

  consumables: "Stock items consumed as part of delivering this service.",
  administered: "Medicines or items administered during the service.",
  prescription: "Take-home prescription items linked to this service variant.",
  itemName: "Stock or product item used for this line.",
  billableQty: "Quantity billed or consumed for this item.",
  uom: "Unit of measure for the quantity.",
  dose: "Dosage amount for administration.",
  route: "Route of administration (e.g., oral, IV, topical).",
  frequency: "How often the item should be administered.",
  duration: "Length of the prescription course.",
  instructions: "Special administration or usage instructions.",
  remarks: "Additional notes for this line item.",
  defaultItem: "Mark as the default alternate when multiple options exist.",
};
